import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Mail } from 'lucide-react';

const NotFound = () => {
    useEffect(() => {
        document.title = "404 - Page Not Found | Go Nova";
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center relative overflow-hidden pt-24 px-4">

            {/* Background elements */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-[120px] pointer-events-none" />

            <div className="relative z-10 glass-panel p-12 max-w-2xl w-full text-center border border-white/10 rounded-3xl shadow-2xl">

                <h1 className="text-[120px] font-black leading-none bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 mb-4 opacity-90 select-none">
                    404
                </h1>

                <h2 className="text-gradient" style={{ fontSize: '3rem', fontWeight: 800, marginBottom: '1.5rem' }}>Lost in the Digital Void?</h2>

                <p className="lead-description" style={{ marginBottom: '2rem' }}>
                    It seems you've ventured into uncharted territory. This page doesn't exist, but don't worry—even the best explorers get lost sometimes.
                </p>

                <p className="text-md text-slate-400 mb-12 italic">
                    "Not all those who wander are lost... but you definitely are." <span className="not-italic">😉</span>
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                    <Link
                        to="/"
                        className="group relative px-8 py-4 bg-white text-black font-bold rounded-xl overflow-hidden shadow-lg shadow-white/10 transition-all hover:scale-105 hover:shadow-white/20 flex items-center gap-2"
                    >
                        <Home size={20} />
                        <span>Take Me Home</span>
                    </Link>

                    <a
                        href="mailto:hello@gonova.media"
                        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors px-6 py-4 rounded-xl hover:bg-white/5 border border-transparent hover:border-white/10"
                    >
                        <Mail size={20} />
                        <span className="font-semibold">hello@gonova.media</span>
                    </a>
                </div>

                <div className="mt-12 pt-8 border-t border-white/5 text-sm text-slate-500">
                    If you believe this is an error, please contact our support team.
                </div>
            </div>
        </div>
    );
};

export default NotFound;
